import { ILoginPage } from './types';

/** Страница авторизации оператора сервиса уведомлений. */
export function LoginPage({
  theme,
  stageBackground,
  serviceIconUrl,
  isBooting,
  loginValue,
  passwordValue,
  loginPending,
  notificationStack,
  onSubmit,
  onLoginChange,
  onPasswordChange
}: ILoginPage) {
  if (isBooting) {
    return (
      <div className="auth-shell" data-theme={theme}>
        <main className="auth-stage" style={stageBackground} aria-label="Проверка сессии оператора">
          <div className="auth-stage__orb auth-stage__orb--one" aria-hidden="true" />
          <div className="auth-stage__orb auth-stage__orb--two" aria-hidden="true" />

          <section className="auth-card auth-card--loading">
            <div className="auth-loader" aria-hidden="true" />
            <div className="auth-card__content auth-card__content--centered auth-card__content--session-check">
              <h2>Проверяем активную сессию</h2>
              <p>Если действующая сессия найдена, вход будет восстановлен автоматически.</p>
            </div>
          </section>
        </main>

        {notificationStack}
      </div>
    );
  }

  return (
    <div className="auth-shell" data-theme={theme}>
      <main className="auth-stage" style={stageBackground} aria-label="Окно авторизации оператора">
        <div className="auth-stage__orb auth-stage__orb--one" aria-hidden="true" />
        <div className="auth-stage__orb auth-stage__orb--two" aria-hidden="true" />

        <section className="auth-card">
          <div className="auth-card__halo" aria-hidden="true" />

          <div className="auth-card__header">
            <div className="auth-card__icon">
              <img src={serviceIconUrl} alt="Логотип сервиса уведомлений" />
            </div>
            <div className="auth-card__content auth-card__content--compact-title">
              <h2>Вход в сервис уведомлений</h2>
              <p>Используйте логин и пароль учетной записи оператора из CRM-системы.</p>
            </div>
          </div>

          <form className="auth-form" onSubmit={onSubmit}>
            <label>
              Логин
              <input
                type="text"
                autoComplete="username"
                value={loginValue}
                onChange={onLoginChange}
                placeholder="Введите логин оператора"
                required
              />
            </label>

            <label>
              Пароль
              <input
                type="password"
                autoComplete="current-password"
                value={passwordValue}
                onChange={onPasswordChange}
                placeholder="Введите пароль оператора"
                required
              />
            </label>

            <button className="auth-form__submit" type="submit" disabled={loginPending}>
              {loginPending ? 'Проверяем доступ...' : 'Войти в сервис'}
            </button>
          </form>
        </section>
      </main>

      {notificationStack}
    </div>
  );
}
